export default {"src":"/_next/static/media/heart.193f815c.svg","height":968,"width":968,"blurWidth":0,"blurHeight":0};